import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1px;
`;

const StyledButton = styled.div<{
	$direction: 'left' | 'right';
	$disabled: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: ${({ $direction }) =>
		$direction === 'left' ? '10px 0 0 10px' : '0 10px 10px 0'};
	background-color: ${({ $disabled }) =>
		$disabled ? 'rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid
		${({ $disabled }) =>
			$disabled ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.1)'};
	cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${({ $disabled }) =>
		!$disabled &&
		css`
			&:hover {
				background-color: #ffffff;

				img {
					filter: invert(1);
				}
			}
		`}

	img {
		width: 10px;
		height: 10px;
		transition: filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledInput = styled.input`
	display: block;
	border: none;
	outline: none;
	padding: 0;
	background-color: transparent;
	font-family: 'GT Walsheim Pro';
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #ffffff;
	transition: color 0.3s ease;
	user-select: none;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
`;

const StyledInputWrapper = styled.div<{ $disabled: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 70px;
	height: 30px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition:
		background-color 0.3s ease,
		border 0.3s ease;
	gap: 3px;

	${({ $disabled }) =>
		!$disabled
			? css`
					&:hover {
						background-color: #ffffff;

						${Text} {
							color: #000000;
						}

						${StyledInput} {
							color: #000000;
						}
					}
			  `
			: css`
					background-color: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);
					pointer-events: none;

					input {
						user-select: none;
						pointer-events: none;
					}
			  `}

	${Text} {
		color: #ffffff;
		opacity: 0.5;
		transition: color 0.3s ease;
	}
`;

export { StyledButton, StyledContainer, StyledInput, StyledInputWrapper };
